import type { SiteConfig } from '../../../siteContentTypes.ts';

export function AdvancedSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Personnalisation avancée</h2>
      <div className="error-banner" style={{ marginBottom: 16 }}>
        Réservé aux utilisateurs à l'aise avec le CSS. Un CSS invalide peut casser l'affichage de la page — vérifiez toujours avec "Prévisualiser" avant de publier.
      </div>
      <label className="field-label" htmlFor="custom-css">CSS personnalisé (optionnel)</label>
      <textarea
        id="custom-css"
        className="input"
        rows={16}
        style={{ fontFamily: 'monospace', fontSize: 12.5 }}
        value={config.branding.customCss}
        onChange={(e) => update({ branding: { ...config.branding, customCss: e.target.value } })}
        placeholder=".hero h1 { text-transform: uppercase; }"
      />
    </div>
  );
}
